<template>
  <!--12-3教育机构应聘人才应聘案件显示列表-->

  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("allApplications") }}</div>
    <div class="main-box">
      <!-- table部分 -->
      <div class="table">
        <el-table
          @row-click="jump"
          :data="tableData"
          style="width: 98%"
          :max-height="tableHeight"
          @sort-change="changeTableSort"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- ----------------------案件番号---------------------- -->
          <el-table-column
            prop="jobId"
            label="案件番号"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="handleFuzzyAllApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.jobId }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------案件名---------------------- -->
          <el-table-column
            prop="jobName"
            label="案件名"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="handleFuzzyAllApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.jobName }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------医療機関---------------------- -->
          <el-table-column
            prop="medicalName"
            label="医療機関"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @input="handleFuzzyAllApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.medicalName }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------勤務地---------------------- -->
          <el-table-column
            prop="workSpace"
            label="勤務地"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("workLocation") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @input="handleFuzzyAllApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.workSpace }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------掲載日---------------------- -->
          <el-table-column
            prop="createTime"
            label="掲載日"
            width="210"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("payonTheDay") }}</p>
              <el-date-picker
                v-model="searchData5"
                type="datetimerange"
                range-separator="~"
                :start-placeholder="$t('deliveryTimein')"
                :end-placeholder="$t('deliveryTimeout')"
                class="data-timer-picker"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd HH-mm-ss"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------担当者---------------------- -->
          <el-table-column
            prop="responsiblePerson"
            label="担当者"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("inauguration") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @input="handleFuzzyAllApplyJob"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------観覧回数 ---------------------- -->
          <el-table-column
            prop="visitedTime"
            label="観覧回数 "
            sortable
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.visitedTime }}
            </template>
          </el-table-column>
          <!-- ----------------------応募者---------------------- -->
          <el-table-column
            prop="applicant"
            label="応募者"
            sortable
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("candidates") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.resumeCount }}
            </template>
          </el-table-column>
          <!-- ----------------------状態---------------------- -->
          <el-table-column prop="situation" label="状態" width="90">
            <template slot="header">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandStatus">
                <span class="el-dropdown-link">
                  {{ status }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in StatusData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpreviewStatus_dictText
              }}</span>
              <span v-else>{{ scope.row.reviewStatus_dictText }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="total"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AES from "../../js/AES";
import { fuzzyAllApplyJob, queryAllApplyJob1 } from "../../js/api";
import axios from "axios";

export default {
  name: "educationalInstitutionAddRecruiter",
  components: {},
  data() {
    return {
      tableData: [],
      applyId: "", //案件编号
      jobName: "", //案件名
      medicalName: "", //医疗机关
      workSpace: "", //工作地
      createTime: "", //揭载日
      userName: "", //担当者
      visitedTime: "", //浏览次数
      resumeCount: "", //应聘者
      reviewStatus: "", //状态
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "", //表格第九个搜索
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false,
      createTimeEnd: "",
      createTimeStart: "",
      StatusData: [],
      statusCode: "",
      language: "",
      status: "ALL",
      total: 0,
      tableHeight: "" //表格高度
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.showJob();
    this.getReviewStatus();
    this.getTableHeight();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //获取表格高度
    getTableHeight() {
      let tableH = 310; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    languageChange(e) {
      const that = this;
      console.log("------监听数据2------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.showJob();
        that.getReviewStatus();
      }
    },
    //点击行跳转到当前案件下人才页面12-4
    // jump(row){
    //   this.$router.push({
    //     path: '/educationInstitutionCaseResponderViewing',
    //     name: 'educationInstitutionCaseResponderViewing',
    //     params:{
    //       row:row
    //     }
    //   });
    // },

    //跳到12-4
    jump(row) {
      this.$router.push({
        name: "educationInstitutionCaseResponderViewing",
        query: { jobId: row.jobId, applyId: row.applyId }
      });
    },

    showJob() {
      var fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      queryAllApplyJob1(fakeInfo)
        .then(res => {
          console.log("全部应聘案件显示列表");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.tableData = aesFecInfo.data.map(item => {
            item.createTime = item.createTime
              ? item.createTime.split(" ")[0]
              : "";
            return item;
          });
          this.total = aesFecInfo.total;
        })
        .catch(() => {});
    },
    //全部应聘案件显示列表模糊查询
    handleFuzzyAllApplyJob() {
      var fuzzyQueryDTO = {
        createTimeEnd: this.createTimeEnd,
        createTimeStart: this.createTimeStart,
        educationId: "",
        jobId: this.searchData1,
        jobName: this.searchData2,
        medicalName: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        resumeId: "",
        reviewStatus: this.statusCode,
        userName: this.searchData6,
        visitedTime: this.searchData7,
        workSpace: this.searchData4
      };
      fuzzyAllApplyJob(fuzzyQueryDTO)
        .then(res => {
          console.log("--------全部应聘案件显示列表模糊查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(668888, aesFecInfo.data);
            this.tableData = aesFecInfo.data.map(item => {
              item.createTime = item.createTime
                ? item.createTime.split(" ")[0]
                : "";
              return item;
            });
          }
        })
        .catch(res => {
          console.log("全部应聘案件显示列表模糊查询接口异常:", res);
        });
    },
    handleCommandStatus(evt) {
      this.statusCode = evt.code;
      this.status = evt.name;
      this.handleFuzzyAllApplyJob();
    },
    pickerChangeFn(value) {
      if (value === null) {
        this.createTimeStart = "";
        this.createTimeEnd = "";
      }
    },
    dataTimeChange() {
      console.log(this.searchData5);
      this.createTimeStart = this.timeJs(this.searchData5[0]);
      this.createTimeEnd = this.timeJs(this.searchData5[1]);
      this.handleFuzzyAllApplyJob();
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    //
    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.showJob();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.showJob();
    },

    getReviewStatus() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpjobReviewStatus";
      } else {
        dataItems = "jobReviewStatus";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------reviewStatus--------");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.StatusData = aesFecInfo.data;
            console.log(that.StatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
}

.main-box {
  width: 100%;
  height: 80%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.text {
  width: 30px;
  height: 15px;
  left: 478px;

  /* Body */

  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  text-align: center;

  /* 第二主色 */

  color: #fc630c;

  transform: rotate(-20deg);
}

.title-css {
  font-family: "Inter";
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 18px;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 4;
  /*行间距*/
  left: 40.33%;
  right: 30.92%;
  top: 8px;
}

.table /deep/ .el-date-editor {
  width: 210px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: 0;
  width: 40px;
}

.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  float: right;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.table-img-css {
  border-radius: 50%;
}

.operate {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationalViewAllCases/index.vue